<!-- 下拉选择器 -->
<template>
  <el-cascader
    :options="options"
    v-model="cascaderValue"
    v-bind = "{...$attrs}"
    v-on="{...$listeners}"
    clearable
    @change="selectChange"
  ></el-cascader>
</template>

<script>
  import { mapGetters } from 'vuex';
  import {deepCopy} from "../../../util/util";
  import {getCodeTreeByCodeSetId,getCodeTreeByCodeSetIdAndCusId} from "@/api/common/common";

  export default {
    name: 'bsp-dicts-cascader',
    props: {
      //当前选的值
      cascaderValue: {
        type:String,
        default:''
      },
      //当前所选值下的区域划分值
      areaCode: {
        type:String,
        default:''
      },
      // 代码集setId
      dicNum: {
        type: String,
        default: ''
      },
      // 要移除的 itemId,隔开多个
      remNum: {
        type: String,
        default: ''
      },

      // 单选这选数据
      optionsList: {
          type: Array,
          default: () => (
              []
          )
      }
    },
    data() {
      return {
          // 下拉选数据
          options: [],
      }
    },
    computed: {
      ...mapGetters([
        'dicts',
      ]),
    },
    watch: {
    },
    created() {
      if(this.cascaderValue){
          this.cascaderValue = this.cascaderValue.split(",");
      }
     // console.log("级联值1：",this.cascaderValue.split(","));
      console.log("级联值：",this.cascaderValue)
      console.log("this.optionsList：",this.optionsList)
      //  从后台获取的dicts
      if(this.optionsList.length > 0){
        this.options = this.optionsList;

      }else {
        this.getCodeTree()
      }
    },
    mounted() {
    },
    methods: {
      getCodeTree(){
        console.log("代码集")
        console.log(this.dicNum)
        getCodeTreeByCodeSetIdAndCusId(this.dicNum,'sys').then(res =>{
          console.log(res);
          this.options =res.data.data;
        })
      },
      initData(){

      },
      //  预处理下拉选的list
      handleDictc(list, remNum){
          let remNumArrary = []
          let listInnit = deepCopy(list)
          if(remNum){
              remNumArrary = remNum.split(',');
              for(let i = 0; i<remNumArrary.length; i++){
                  for (let j = 0; j < listInnit.length;j++){
                      let index = listInnit[j]['codeItemId'] == remNumArrary[i]
                      if(index){
                          listInnit.splice(j, 1);
                      }
                  }
              }
              // console.log('处理',listInnit)
              this.options = listInnit

          } else{
              this.options = list
              // console.log('ceshi',this.options)
          }
      },
      selectChange(val){
        debugger
        this.options.find(item=>{
          if(item.value==val[val.length-1]){
              this.$emit('update:areaCode',item.cascadeValue)
          }else if(item.children!=null && item.children.length>0){
            item.children.find(children=>{
              if(children.value==val[val.length-1]){
                this.$emit('update:areaCode',children.cascadeValue)
              }
            })
          }
        })
        this.$emit('update:cascaderValue',val[val.length-1])
        this.$emit('selectChange',val[val.length-1])
      }

  }
}
</script>

<style scoped>
  .el-input.el-input--suffix {
    cursor: pointer;
    overflow: hidden;
  }

  .el-input.el-input--suffix.rotate .el-input__suffix {
    transform: rotate(180deg);
  }

  .select-tree {
    max-height: 350px;
    overflow-y: scroll;
  }

  /* 菜单滚动条 */
  .select-tree::-webkit-scrollbar {
    z-index: 11;
    width: 6px;
  }

  .select-tree::-webkit-scrollbar-track,
  .select-tree::-webkit-scrollbar-corner {
    background: #fff;
  }

  .select-tree::-webkit-scrollbar-thumb {
    border-radius: 5px;
    width: 6px;
    background: #b4bccc;
  }

  .select-tree::-webkit-scrollbar-track-piece {
    background: #fff;
    width: 6px;
  }
  .el-form-item__content{
    height:28px;
  }
</style>
